import React from "react";
import ShareIcon from "@mui/icons-material/Share";
import { toast } from "react-toastify";
import { Button } from "./index";
import { trackShare } from "../../utility/analytics.utils";

interface ShareButtonProps {
  title?: string;
  subtitle?: string;
  iconOnly?: boolean;
  storyId?: string;
  chapterId?: string;
}

const ShareButton = ({ title, subtitle, iconOnly = false, storyId, chapterId }: ShareButtonProps) => {
  const handleShare = async () => {
    const shareData = {
      title,
      text: subtitle || "Check out this story!",
      url: window.location.href,
    };

    // Determine content type and ID for tracking
    const contentType = chapterId ? "chapter" : "story";
    const contentId = chapterId || storyId || "";

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        // Track native share (platform unknown, so we'll track as generic share)
        // For native share, we can't determine the exact platform, so we'll track as "copy_link"
        // since it's essentially sharing via the device's native share sheet
        if (contentId) {
          trackShare(contentType as "story" | "chapter", contentId, "copy_link");
        }
      } catch (err) {
        // User cancelled or error - don't track
        if (err instanceof Error && err.name !== "AbortError") {
          console.error("Sharing failed:", err);
        }
      }
    } else {
      try {
        await navigator.clipboard.writeText(window.location.href);
        toast.info("Story link copied to clipboard!");
        // Track copy link action
        if (contentId) {
          trackShare(contentType as "story" | "chapter", contentId, "copy_link");
        }
      } catch (err) {
        console.error("Copy failed:", err);
        toast.error("Could not copy link. Please try again.");
      }
    }
  };

  if (iconOnly) {
    return (
      <Button
        variant="icon"
        onClick={handleShare}
        sx={{ minWidth: "auto", width: 40, height: 40, p: 0 }}
      >
        <ShareIcon sx={{ fontSize: 20 }} />
      </Button>
    );
  }

  return (
    <Button variant="outlined" onClick={handleShare} startIcon={<ShareIcon />}>
      Share
    </Button>
  );
};

export default ShareButton;
